import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import WinterizeRV from "@/pages/WinterizeRV";

export const Route = createFileRoute("/rv-how-to-winterize-my-rv")({
  head: () => pageHead({
    title: 'How to Winterize Your RV',
    description: 'Learn how to winterize your RV plumbing and systems — a step-by-step guide from Rex & Sons RVs in Castle Hayne, NC.',
    path: '/rv-how-to-winterize-my-rv',
  }),
  component: WinterizeRV,
});
